import { createApp } from 'vue'

/**
 * Creates a Vue instance for each element matching the selector.
 * @param {string} selector - CSS selector
 * @param {Object} options - Vue instance options
 * @param {function} setup - Optional setup function to execute on Vue instance
 */
function createVueInstance(selector, options, setup) {
  const elements = Array.from(document.querySelectorAll(selector))
  
  elements.forEach(element => {
    const app = createApp(options)
    if (setup) {
      setup(app)
    }
    
    app.mount(element)
  })
}

// Import components
import SearchComponent from './components/SearchComponent.vue'
import NewsListingComponent from './components/NewsListingComponent.vue'

// Create Vue instances

/**
 * Example component usage:
 * <div class="vue-example-component">
 *   <example-component message="Example prop value">
 *     <template #content>
 *       Example <strong>slot content</strong>
 *     </template>
 *   </example-component>
 * </div>
 */
createVueInstance(
  '.vue-search-component',
  {
    components: {
      SearchComponent
    }
  }
)

createVueInstance(
  '.vue-news-listing-component',
  {
    components: {
      NewsListingComponent
    }
  }
)